export default "__VITE_ASSET__C7DmVd3h__"